
import { defineComponent, onMounted, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { useStore } from "vuex";
import { getSystemConfig } from "@/service/system-config";
import { appUpdateAvailable } from "@/util/app-version";
export default defineComponent({
  setup() {
    onMounted(async () => {
      Object.assign(systemConfig.value, (await getSystemConfig()).data);
    });
    const systemConfig = ref<any>({});
    const store = useStore();

    const updateApp = () => {
      ElMessageBox.confirm(
        "更新將重新載入頁面，尚未儲存的內容將會遺失。是否立即更新？",
        "版本更新",
        {
          confirmButtonText: "立即更新",
          cancelButtonText: "稍後更新",
          type: "warning",
        },
      )
        .then(() => window.location.reload())
        .catch(() => undefined);
    };

    const open = () => {
      ElMessageBox.confirm("確定要登出?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ElMessage({
            type: "success",
            message: "成功登出!",
          });
          window.localStorage.removeItem("lineAccessToken");
          window.location.reload();
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "取消登出",
          });
        });
    };
    return {
      systemConfig,
      clientName: store.state.clientName,
      userData: store.state.userData,
      appUpdateAvailable,
      updateApp,
      open,
    };
  },
});
